import { isEmpty } from 'lodash';
import WidgetClient from '../../clients/WidgetClient';
import WidgetConnectionConfig from '../../models/WidgetConnectionConfig';

function transformSaveWidgetConnectionRequest(requestBody) {
  return {
    body: requestBody,
    method: WidgetClient.HTTP_METHODS.POST,
  };
}

function transformGetToSAgreementRequest(requestBody) {
  return {
    body: requestBody,
    method: WidgetClient.HTTP_METHODS.GET,
  };
}

function transformPostToSAgreementRequest(requestBody) {
  return {
    body: requestBody,
    method: WidgetClient.HTTP_METHODS.POST,
  };
}

function transformUpdateWidgetConnectionRequest(requestBody) {
  return {
    body: requestBody,
    method: WidgetClient.HTTP_METHODS.PATCH,
  };
}

function transformSaveWidgetViewRequest(requestBody) {
  return {
    body: requestBody,
    method: WidgetClient.HTTP_METHODS.PUT,
  };
}

function transformSaveWidgetLayoutRequest(requestBody) {
  return {
    body: requestBody,
    method: WidgetClient.HTTP_METHODS.PUT,
  };
}

function transformWidgetConnectionResponse(response) {
  let widgetConnection = null;
  if (!isEmpty(response)) {
    widgetConnection = new WidgetConnectionConfig({ ...response });
  }
  return widgetConnection;
}

function transformWidgetViewResponse(response) {
  let widgetView = null;
  if (!isEmpty(response)) {
    widgetView = response.data;
  }
  return widgetView;
}

export default {
  transformGetToSAgreementRequest,
  transformPostToSAgreementRequest,
  transformSaveWidgetConnectionRequest,
  transformUpdateWidgetConnectionRequest,
  transformSaveWidgetViewRequest,
  transformSaveWidgetLayoutRequest,
  transformWidgetConnectionResponse,
  transformWidgetViewResponse,
};
